import './isi.scss';

import { IoMdDownload } from 'react-icons/io';
import { h, Component } from 'preact';
import { BaseAnnotation } from './base_annotation';
import { accessible } from 'utilities/accessibility';
import { expandable } from 'rendering/behaviors/expandable';
import { COMPOSITION_TYPES, getCompositionInfo } from 'constants/annotations';
import { ControlBar } from 'rendering/components/adjacent_control_bar';
import * as is from 'utilities/is'

const { ISI } = COMPOSITION_TYPES;

@expandable
export class ISIAnnotation extends BaseAnnotation {
    static scalable = false;

    constructor(props) {
        super(props);
        this.state.expanded = !!(props.parentState && props.parentState.expanded);
    }

    applyActions(...args) {
        const applied = super.applyActions(...args); 

        return {
            ...applied,
            onClick: (...args) => {
                if (is.fn(applied.onClick)) {
                    applied.onClick(...args)
                }

                this.onExpand(...args)
            }
        }
    }

    render() {
        const rootAttrs = { 
            ...this.dataAttrs,
            ...this.applyActions(this.actions),
            className: "popcorn-isi gradient-overlay",
            style: this.getElementStyles(),
            role: "article",
            ariaLabel: "Important Safety Information" 
        }

        return (
            <div  { ...rootAttrs }>
                <ControlBar onExpand={ this.onExpand } onCollapse={ this.onCollapse } styles={ this.controlBarStyles } />
                <div className="isi-annotation">
                    { this.prescriberDownload }
                    { this.contents }
                </div>
            </div>
        );
    }

    onDownloadClick = e => e.stopPropagation()

    componentWillReceiveProps({ parentState = {} }) {
        this.setState({ expanded: parentState.expanded });
    }

    get prescriberDownload() {
        if (this.hasPrescriptionInfo) {
            return (
                <div className="header-download">
                    <a download target="_blank" style={ this.getElementStyles(ISI.DOWNLOAD_LINK) } href={ this.props.properties.headerDownloadUrl } onClick={ this.onDownloadClick } { ...accessible(this.onDownloadClick) }>
                        <IoMdDownload className="download-icon"/>
                        { this.props.properties.headerDownloadText || 'Download Prescriber Information' }
                    </a>
                </div>
            );
        }

        return null;
    }

    get hasPrescriptionInfo() {
        return this.props.properties && this.props.properties.headerDownloadUrl;
    }

    static get composition() {
        return getCompositionInfo('ISI');
    }

    static get schemaType() {
        return 'isi';
    }
}